import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const authService = {
  autoLogin: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.autoLogin,
      payload,
      headers,
      hasErrorHandler,
    }),
  login: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.login,
      payload,
      headers,
      hasErrorHandler,
    }),
  register: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.register,
      payload,
      headers,
      hasErrorHandler,
    }),

  logout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.logout,
      payload,
      headers,
      hasErrorHandler,
    }),

  changeCurrencyAndLanguage: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.changeCurrencyAndLanguage,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFlightPassengers: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.auth.getFlightPassengers,
      payload,
      headers,
      hasErrorHandler,
    }),
};
